"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    $id: 'http://cadstrom.io/api/v1/edrc/schema/cadstromv1_1configschema.json',
    $schema: 'http://json-schema.org/draft-07/schema#',
    additionalProperties: false,
    definitions: {
        BuildConfigurationCheckId: {
            enum: ['footprintReference', 'insights'],
            type: 'string',
        },
        CadSemanticFileType: {
            enum: ['board', 'schematic', 'lib', 'dru', 'project', 'other'],
            type: 'string',
        },
        CadstromV1_1BoardConfig: {
            additionalProperties: false,
            properties: {
                approvals: {
                    items: {
                        type: 'string',
                    },
                    type: 'array',
                },
                dru: {
                    anyOf: [
                        {
                            type: 'string',
                        },
                        {
                            $ref: '#/definitions/ICadstromV1_1DruConfig',
                        },
                    ],
                },
                file: {
                    type: 'string',
                },
                name: {
                    type: 'string',
                },
            },
            required: ['file'],
            type: 'object',
        },
        CadstromV1_1IncludeConfig: {
            additionalProperties: false,
            properties: {
                file: {
                    type: 'string',
                },
                name: {
                    type: 'string',
                },
                type: {
                    $ref: '#/definitions/CadSemanticFileType',
                },
            },
            required: ['file', 'type'],
            type: 'object',
        },
        CadstromV1_1ProjectConfig: {
            additionalProperties: false,
            properties: {
                boards: {
                    items: {
                        $ref: '#/definitions/CadstromV1_1BoardConfig',
                    },
                    type: 'array',
                },
                checks: {
                    $ref: '#/definitions/IBuildCheck',
                },
                includes: {
                    items: {
                        $ref: '#/definitions/CadstromV1_1IncludeConfig',
                    },
                    type: 'array',
                },
                schematics: {
                    items: {
                        $ref: '#/definitions/CadstromV1_1SchematicConfig',
                    },
                    type: 'array',
                },
                type: {
                    enum: ['eagle', 'kicad', 'altium'],
                    type: 'string',
                },
            },
            required: ['type'],
            type: 'object',
        },
        CadstromV1_1SchematicConfig: {
            additionalProperties: false,
            properties: {
                file: {
                    type: 'string',
                },
                lib: {
                    type: 'string',
                },
                name: {
                    type: 'string',
                },
            },
            required: ['file'],
            type: 'object',
        },
        IBuildCheck: {
            additionalProperties: false,
            properties: {
                footprintReference: {
                    $ref: '#/definitions/IBuildCheckConfiguration%3CIFootprintReferenceCheckSettings%3E',
                },
                insights: {
                    $ref: '#/definitions/IBuildCheckConfiguration%3CIInsightsCheckSettings%3E',
                },
            },
            type: 'object',
        },
        'IBuildCheckConfiguration<IFootprintReferenceCheckSettings>': {
            additionalProperties: false,
            properties: {
                enabled: {
                    type: 'boolean',
                },
                id: {
                    $ref: '#/definitions/BuildConfigurationCheckId',
                },
                settings: {
                    $ref: '#/definitions/IFootprintReferenceCheckSettings',
                    description: 'The configured settings for the check',
                },
            },
            required: ['id', 'enabled', 'settings'],
            type: 'object',
        },
        'IBuildCheckConfiguration<IInsightsCheckSettings>': {
            additionalProperties: false,
            properties: {
                enabled: {
                    type: 'boolean',
                },
                id: {
                    $ref: '#/definitions/BuildConfigurationCheckId',
                },
                settings: {
                    $ref: '#/definitions/IInsightsCheckSettings',
                    description: 'The configured settings for the check',
                },
            },
            required: ['id', 'enabled', 'settings'],
            type: 'object',
        },
        ICadstromV1_1DruConfig: {
            additionalProperties: false,
            properties: {
                file: {
                    type: 'string',
                },
                layers: {
                    anyOf: [
                        {
                            type: 'string',
                        },
                        {
                            items: {
                                type: 'string',
                            },
                            type: 'array',
                        },
                    ],
                },
            },
            required: ['file'],
            type: 'object',
        },
        IFootprintReferenceCheckSettings: {
            additionalProperties: false,
            properties: {
                mechanicalCompatibilityCheck: {
                    additionalProperties: false,
                    properties: {
                        enabled: {
                            description: 'Whether the mechanical compatibility check is enabled.',
                            type: 'boolean',
                        },
                        mechanicalCompatibilityWarningTolerance: {
                            description: 'Configures the maximum tolerance (as a percentage of pad area) for the mechanical compatibility check. Differences greater than this tolerance will be reported as an error.',
                            type: 'number',
                        },
                        referenceComponentSpec: {
                            description: 'The IPC specification to use for the reference component.\n\nThis setting is only configurable for users with the advancedFootprintReferenceCheck plan feature. This setting is ignored if the mechanical compatibility check is disabled.\n\nMeanings:\n- ipc-mmc: Maximum Material Condition\n- ipc-nmc: Nominal Material Condition\n- ipc-lmc: Least Material Condition',
                            enum: ['ipc-mmc', 'ipc-nmc', 'ipc-lmc'],
                            type: 'string',
                        },
                    },
                    required: ['enabled', 'mechanicalCompatibilityWarningTolerance', 'referenceComponentSpec'],
                    type: 'object',
                },
                pinAssignmentCheck: {
                    additionalProperties: false,
                    properties: {
                        enabled: {
                            description: 'Whether the pin assignment check is enabled.',
                            type: 'boolean',
                        },
                    },
                    required: ['enabled'],
                    type: 'object',
                },
            },
            type: 'object',
        },
        IInsightsCheckSettings: {
            additionalProperties: false,
            properties: {
                enabled: {
                    type: 'boolean',
                },
            },
            type: 'object',
        },
    },
    properties: {
        project: {
            $ref: '#/definitions/CadstromV1_1ProjectConfig',
        },
        version: {
            type: ['number', 'string'],
        },
    },
    required: ['version', 'project'],
    type: 'object',
};
//# sourceMappingURL=CadstromV1ConfigSchema.js.map